import { render, staticRenderFns } from "./SiteMain.vue?vue&type=template&id=54ece419&scoped=true"
import script from "./SiteMain.vue?vue&type=script&lang=js"
export * from "./SiteMain.vue?vue&type=script&lang=js"
import style0 from "./SiteMain.vue?vue&type=style&index=0&id=54ece419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ece419",
  null
  
)

export default component.exports